import { select } from '../../../_shared/utils/saga/effects';
import { primarySpreadsheetIdSelector } from '../../mapInfo/mapInfo.selectors';
import { mapSettingsDataSelector } from '../../mapSettings/data/mapSettingsData.selectors';
import { type MapSettingsDataState } from '../../mapSettings/data/mapSettingsData.state';
import {
  getAllFilterTreeRequestsFromMapSettings,
  getCombinedFilterTreeForSpreadsheetId,
} from '../filtering/spreadsheetDataFiltering.helpers';
import { getFilterTreeParamsFromMapSettings } from '../filtering/useFilterTreeMapSettingsParams';

export function* getStoreFilterTree() {
  const mapSettingsData: MapSettingsDataState = yield select<MapSettingsDataState>(mapSettingsDataSelector);
  const primarySpreadsheetId: ReturnType<typeof primarySpreadsheetIdSelector> = yield select(primarySpreadsheetIdSelector);

  if (primarySpreadsheetId === null) {
    return null;
  }

  const filterTreeParams = getFilterTreeParamsFromMapSettings(mapSettingsData);
  const allFilterTreeRequests = getAllFilterTreeRequestsFromMapSettings(filterTreeParams, [primarySpreadsheetId]);
  return getCombinedFilterTreeForSpreadsheetId(allFilterTreeRequests, primarySpreadsheetId);
}
